/**
 * Fixed announcement for when typing stops.
 */
export const TYPING_STOPPED_ANNOUNCEMENT = 'Typing stopped.';

/**
 * Builds the accessible typing aggregation label from typer display names,
 * ordered oldest typing session first (same order as the store).
 *
 * - 0 → `null` (nothing to announce)
 * - 1 → "[Name] is typing."
 * - 2 → "[Name 1] and [Name 2] are typing."
 * - 3+ → "Several people are typing."
 */
export const getTypingAccessibleLabel = (names: string[]): string | null => {
  const count = names.length;

  if (count === 0) {
    return null;
  }

  if (count >= 3) {
    return 'Several people are typing.';
  }

  if (count === 1) {
    return `${names[0]} is typing.`;
  }

  return `${names[0]} and ${names[1]} are typing.`;
};
